import React from 'react';

export const SearchIcon = ({ width = 18, height = 18, color = '#2E2E34' }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3899 10.8535H11.9824L15.1624 14.0485C15.4699 14.356 15.4699 14.8585 15.1624 15.166C14.8549 15.4735 14.3524 15.4735 14.0449 15.166L10.8574 11.9785V11.386L10.6549 11.176C9.6049 12.076 8.1724 12.541 6.6499 12.286C4.5649 11.9335 2.8999 10.1935 2.6449 8.0935C2.2549 4.921 4.9249 2.251 8.0974 2.641C10.1974 2.896 11.9374 4.561 12.2899 6.646C12.5449 8.1685 12.0799 9.601 11.1799 10.651L11.3899 10.8535ZM4.10736 7.4786C4.10736 9.3461 5.61486 10.8536 7.48236 10.8536C9.34986 10.8536 10.8574 9.3461 10.8574 7.4786C10.8574 5.6111 9.34986 4.1036 7.48236 4.1036C5.61486 4.1036 4.10736 5.6111 4.10736 7.4786Z"
      fill={color}
    />
  </svg>
);
